import React from "react";
import { SubjectOutcomesCard } from "./SubjectOutcomesCard";
import { SubjectOutcomesUIProvider } from "./SubjectOutcomesUIContext";

export function SubjectOutcomesPage({
  history,
  match: {
    params: { page, subjectId, courseId }
  }
 }) {
  const subjectOutcomesUIEvents = {
    openCourseSubjectListPage: () => {
      if (page === "ogretmen") history.push(`/ogretmen/ders-konulari/${courseId}`);
      else if (page === "ogrenci") history.push(`/ogrenci/ders-konulari/${courseId}`);
      else history.push(`/ders-konulari/${courseId}`);
    },
    openNewSubjectOutcomePage: () => {
      if (page === "ogretmen") history.push(`/ogretmen/konu-kazanimlari/ekle/${subjectId}/${courseId}`);
      else history.push(`/konu-kazanimlari/ekle/${subjectId}/${courseId}`);
    },
    openEditSubjectOutcomePage: (id) => {
      if (page === "ogretmen") history.push(`/ogretmen/konu-kazanimlari/duzenle/${id}/${subjectId}/${courseId}`);
      else history.push(`/konu-kazanimlari/duzenle/${id}/${subjectId}/${courseId}`);
    },
  };
  
  return (
    <SubjectOutcomesUIProvider subjectId={subjectId} subjectOutcomesUIEvents={subjectOutcomesUIEvents}>
      <SubjectOutcomesCard />
    </SubjectOutcomesUIProvider>
 );
}